import { memo, Suspense } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom"
import { ThemeProvider } from "styled-components"
import { Theme } from "../theme"

import 'i18n'

import LandingPage from 'Pages/Landing'
import ChoseGamePage from 'Pages/ChoseGame'
import RefPage from 'Pages/Ref'
import ApplicationMainPage from 'Pages/Application/Main'
import ApplicationFriendsPage from 'Pages/Application/Friends'
import AuthPage from 'Pages/Auth'

// contexts w
import ApplicationContext from 'contexts/application-context'

const Provider = ({ children }) => {

  const getRouting = () => {

    const SUB_DOMAIN = window.location.host.split(".")[0];

    switch (SUB_DOMAIN) {
      case 'app':
        return (
          <Routes>
            <Route path="/" element={<ChoseGamePage />}></Route>
            <Route path="/auth/:page" element={<AuthPage />}></Route>
          </Routes>
        )

      case 'valorant':
      case 'csgo':
        return (
          <ApplicationContext.Provider value={{ game: SUB_DOMAIN }}>
            <Routes>
              <Route path="/" element={<ApplicationMainPage />} />
              <Route path="/friends" element={<ApplicationFriendsPage />} />
            </Routes>
          </ApplicationContext.Provider>
        )

      default:
        return (
          <Routes>
            <Route path="/" element={<LandingPage />}></Route>
            <Route path="ref/:ref" element={<RefPage />}></Route>
          </Routes>
        )
    }

  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider theme={Theme}>
        <BrowserRouter>

          {getRouting()}

        </BrowserRouter>
        {children}
      </ThemeProvider>
    </Suspense>
  )
}

export default memo(Provider)